import { NodeStatus } from 'components';
import { usePerms } from 'contexts/PermsContext';
import { hasDevicePermissionFromDevice } from 'features/integrations/features/ConnectedSystems/utils/devicePermissionUtils';
import {
  openAwareSettings,
  openDeviceSettings,
  openUSGSSettings,
  setSelectedDeviceId,
} from 'features/integrations/state/slices/deviceSlice';
import { setSelectedDevice } from 'features/integrations/state/thunks';
import { DeviceIsSystemType } from 'features/integrations/utils/deviceComparisionUtils';
import { FaCog } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

/**
 * @param {{devices: object[], setSelectedDevice: (index: number, id?: number), onOpenDevice: ()}}
 */
export default function DeviceRow({ onOpenDevice = () => {}, devices, widget = false }) {
  const perms = usePerms();
  const dispatch = useDispatch();

  const onSelectDevice = (deviceId) => {
    // Always select by device id to keep map, graph, and list in sync
    dispatch(setSelectedDevice({ index: -1, id: deviceId }));
    dispatch(setSelectedDeviceId(deviceId));
  };

  const onSettingsClick = (e, device) => {
    if (DeviceIsSystemType(device, 'Flood')) {
      e.stopPropagation();
      dispatch(openAwareSettings(device.id));
    } else if (device.system_type === 'USGS') {
      e.stopPropagation();
      dispatch(openUSGSSettings(device.id));
    } else {
      e.stopPropagation();
      dispatch(openDeviceSettings(device.id));
    }
  };

  const onRowClick = (device) => {
    console.log('DeviceRow onRowClick device:', device);
    onSelectDevice(device.id);

    // AWARE and USGS devices open datasheets
    if (device.system_type === 'USGS' || DeviceIsSystemType(device, 'Flood')) {
      onOpenDevice(device.id);
      return;
    }

    if (!widget) {
      dispatch(openDeviceSettings({ id: device.id, deviceSettings: device }));
    } else {
      dispatch(openDeviceSettings(device.id));
    }
  };

  return (
    <div>
      {devices.map((device, index) => (
        <div
          key={device.id || index}
          className={`row p-1 ${index % 2 ? 'bg-primary' : ''}`}
          onClick={() => onRowClick(device)}
        >
          <div
            className="col-12 col-lg-4 overflow-hidden text-truncate"
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              whiteSpace: 'normal',
              minWidth: 0,
            }}
          >
            <p className="m-0">
              <span className="d-inline d-lg-none">Device: </span>
              {`${device.static_id ? device.static_id + ' ' : ''}${device.alias}`}
            </p>
          </div>
          <div className="col-12 col-lg-2">
            <p className="m-0">
              {' '}
              <span className="d-inline d-lg-none">Node ID: </span>
              {device.node_id}
            </p>
          </div>

          <div className="col-10 col-lg-4 d-flex align-items-center">
            <NodeStatus device={device} />
          </div>

          {hasDevicePermissionFromDevice(perms, device, 'createEdit') && (
            <div className="col-2" onClick={(e) => onSettingsClick(e, device)}>
              <FaCog size={25} />
            </div>
          )}

          {!hasDevicePermissionFromDevice(perms, device, 'createEdit') && <div className="col-2" />}
        </div>
      ))}
    </div>
  );
}
